import React from 'react';

export default function NewlineText({text}) {
    if(text) {
        return text.split('\n').map((str, index) => <p key={index}>{str}</p>);
    } else {
        return "";
    }
}
